import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { login } from "../_redux/authCrud";
import axios from "axios";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import moment from "moment";

const initialValues = {
  // email: "admin@demo.com",
  // password: "demo",
  // email: "super@gamerji.com",
  // password: "12345678",
  email: "",
  password: "",
  otp: "",
};

function formatTime(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return [h > 0 ? `${h}h ` : "", m > 0 || h > 0 ? `${m}m ` : "", `${s}s`].join(
    ""
  );
}

function useCountdown(initialSeconds) {
  const [timerCount, setTimer] = useState(initialSeconds);

  useEffect(() => {
    if (timerCount <= 0) {
      return;
    }

    const timerId = setTimeout(() => {
      setTimer(timerCount - 1);
    }, 1000);

    return () => clearTimeout(timerId);
  }, [timerCount]);

  return [timerCount, setTimer];
}

function Login(props) {
  const history = useHistory();
  const { intl } = props;
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [step, setStep] = useState(1);
  const [otpRequested, setOtpRequested] = useState(false);
  const [showOTPField, setShowOTPField] = useState(false);
  const [editableEmail, setEditableEmail] = useState(true);
  const [timerCount, setTimer] = useCountdown(300); // Initialize timer with 300 seconds
  const [otp, setOtp] = useState("");

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .when("buttonType", {
        is: "otpRequest",
        then: Yup.string().required("Email is required for OTP request"),
      })
      .when("buttonType", {
        is: "signinSubmit",
        then: Yup.string().required("Email is required"),
      }),
    otp: Yup.string().when("buttonType", {
      is: "signinSubmit",
      then: Yup.string()
        .required("OTP is required")
        .length(6, "OTP must be 6 characters"),
    }),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      setErrorMsg(null);

      try {
        let response;

        if (values.buttonType === "otpRequest") {
          if (!formik.isValid) {
            return;
          }
          setEditableEmail(false);
          response = await login({
            email: values.email,
            type: "otpRequest",
          });
          if (response.success) {
            setStep(2);
          } else {
            setEditableEmail(true);
            NotificationManager.error(response?.errors[0].msg, "Error");
          }
          // if(response)
          // Handle the response for OTP request
        } else if (values.buttonType === "signinSubmit") {
          if (!formik.isValid) {
            // Handle form validation errors for OTP validation
            return;
          }

          response = await login({
            email: values.email,
            type: "validate",
            otp: values.otp,
          });
          // console.log(response?.errors?.[0].msg);
          // Handle the response for OTP validation
          if (response && response.success) {
            setLoading(false);
            setErrorMsg(null);
            props.login(response);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else {
            NotificationManager.error(response?.errors[0].msg, "Error");
          }
        }

        if (response && response.success) {
          console.log("Formik Values:", values);
        }
      } catch (error) {
        console.error("API Call Error:", error);
        setErrorMsg(
          error?.response?.data?.errors[0]?.msg || "An error occurred"
        );
        setStatus(
          intl.formatMessage({
            id:
              error?.response?.data?.errors[0]?.msg ||
              "AUTH.VALIDATION.INVALID_LOGIN",
          })
        );
      } finally {
        setLoading(false);
        setSubmitting(false);
      }
    },
  });

  const setCountDownTimer = () => {
    setTimer(timerCount - 1);
  };

  useEffect(() => {
    // Create Web Worker from Blob URL
    const workerBlob = new Blob(
      [
        `
        self.onmessage = function(event) {
          let timerCount = event.data;
          
          const intervalId = setInterval(() => {
            timerCount--;
            if (timerCount <= 0) {
              clearInterval(intervalId);
            }
            // Send timerCount back to the main script
            postMessage(timerCount);
          }, 1000);
        };
        `,
      ],
      { type: "application/javascript" }
    );

    const workerUrl = URL.createObjectURL(workerBlob);
    const worker = new Worker(workerUrl);

    // Message handler to receive updates from the Web Worker
    worker.onmessage = function(event) {
      const newTimerCount = event.data;
      setTimer(newTimerCount); // Corrected the state setter function name
    };

    // Start the Web Worker with initial timerCount
    worker.postMessage(timerCount);

    // Clean up the worker and URL when component unmounts
    return () => {
      worker.terminate();
      URL.revokeObjectURL(workerUrl);
    };
  }, []);
  const resetOtp = async () => {
    try {
      let response = await login({
        email: formik.values.email,
        type: "otpRequest",
      });
      if (response.success) {
        setTimer(300); // Reset timer to 5 minutes
        NotificationManager.success(
          "OTP has been sent to your registered email address",
          "Success"
        );
      } else {
        setEditableEmail(true);
        NotificationManager.error(response?.errors[0].msg, "Error");
      }
    } catch (error) {
      // Handle error
    }
  };

  return (
    <div className="login-form" id="kt_login_signin_form">
      <NotificationContainer />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit();
        }}
        className="form fv-plugins-bootstrap fv-plugins-framework"
        id="kt_login_singin_form"
      >
        <div className="pb-5 pb-lg-15">
          <h3 className="font-weight-bolder text-light font-size-h2 font-size-h1-lg text-center">
            <FormattedMessage id="AUTH.LOGIN.TITLE" />
          </h3>
        </div>

        {formik.status ? (
          <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
            <div className="alert-text font-weight-bold">{formik.status}</div>
          </div>
        ) : null}

        <div className="form-group">
          <label className="font-size-h6 font-weight-bolder text-light">
            Email
          </label>
          <input
            placeholder="Email"
            type="email"
            style={{ background: "#fff" }}
            className={`form-control form-control-solid h-55px py-7 px-6 rounded-lg border-0 ${getInputClasses(
              "email"
            )}`}
            name="email"
            readOnly={!editableEmail}
            {...formik.getFieldProps("email")}
          />
          {formik.touched.email && formik.errors.email ? (
            <div className="fv-plugins-message-container mt-3">
              <div
                className="fv-help-block"
                style={{ color: "red", fontSize: "15px", fontWeight: 100 }}
              >
                {formik.errors.email}
              </div>
            </div>
          ) : null}

          {step === 2 && (
            <>
              <label className="font-size-h6 font-weight-bolder text-light mt-5">
                Enter OTP
              </label>
              <input
                placeholder="OTP"
                type="number"
                style={{ background: "#fff", borderRadius: "10px" }}
                className={`form-control form-control-solid h-55px py-7 px-6 rounded-lg border-0 ${getInputClasses(
                  "otp"
                )}`}
                name="otp"
                maxLength={6}
                onInput={(event) => {
                  if (event.target.value.length > 6) {
                    event.target.value = event.target.value.slice(0, 6);
                  }
                }}
                {...formik.getFieldProps("otp")}
              />
              {formik.touched.otp && formik.errors.otp ? (
                <div className="fv-plugins-message-container mt-3">
                  <div
                    className="fv-help-block"
                    style={{ color: "red", fontSize: "15px", fontWeight: 100 }}
                  >
                    {formik.errors.otp}
                  </div>
                </div>
              ) : null}
              <div class="resend-otp-msg">
                <h5>
                  <span> Didn’t receive Verification Code?</span>
                </h5>
              </div>
              <div className="resend-otp">
                {timerCount === 0 ? (
                  <h5>
                    <span className="resend-button" onClick={resetOtp}>
                      Resend
                    </span>
                  </h5>
                ) : (
                  <h5 className="d11-text-center">
                    <span className="link-offset-2 link-underline link-underline-opacity-0 verification-link d11-otp-resend">
                      Request for a new one in {formatTime(timerCount)}
                    </span>
                  </h5>
                )}
              </div>
            </>
          )}
        </div>

        <div
          className="form-group d-flex flex-wrap justify-content-between align-items-center"
          style={{ marginLeft: "36.5%" }}
        >
          {step === 1 && (
            <button
              id="kt_login_request_otp"
              type="button"
              onClick={() => {
                formik.setValues({
                  ...formik.values,
                  buttonType: "otpRequest",
                });
                formik.handleSubmit();
              }}
              disabled={formik.isSubmitting || !formik.values.email || loading}
              style={{ color: "#233a55", background: "#fff" }}
              className={`btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-3`}
            >
              <span>Request OTP</span>
              {loading && <span className="ml-3 spinner spinner-white"></span>}
            </button>
          )}
          {step === 2 && (
            <button
              id="kt_login_signin_submit"
              type="submit"
              disabled={formik.isSubmitting || !formik.values.otp}
              onClick={() => {
                formik.setValues({
                  ...formik.values,
                  buttonType: "signinSubmit",
                });

                formik.handleSubmit();
              }}
              style={{ color: "#233a55", background: "#fff" }}
              className={`btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-3`}
            >
              <span>Sign In</span>
              {loading && <span className="ml-3 spinner spinner-white"></span>}
            </button>
          )}
        </div>
      </form>
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(Login));
